import { useCerberus } from "../../hooks/useCerberus";
import { audienceForRoles, Audience } from "./audience";

export type { Audience };

/** Resolve the signed-in user's audience. See `audienceForRoles` for the precedence rules. */
export function useAudience(): { audience: Audience | null; loading: boolean } {
  const { roles, loading } = useCerberus();

  return { audience: audienceForRoles(roles), loading };
}
